import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit } from "@angular/core";
import { IPlannedRouteVisit } from "@tms/_models/IPlannedRouteVisit";
import { IPlannedRouteDetail, PlannedRouteService, selectMany } from "@tms/_services/planned-route.service";
import { VisitOnTimeStatus } from "../../_enums/VisitOnTimeStatus";
import "./route-performance-bar.component.scss";

export interface IBarSegment {
    count: number;
    percentage: number;
    label: string;
    className: string;

    showText: boolean;
    showNumber: boolean;
    showPercentage: boolean;

    tooltip?: string;


}

@Component({
    selector: "route-performance-bar",
    template: require("./route-performance-bar.component.html")
})
export class RoutePerformanceBarComponent implements OnChanges, OnInit, AfterViewInit {

    @Input() route: IPlannedRouteDetail;
    @Input() routes: IPlannedRouteDetail[];

    // ---

    segments: IBarSegment[] = [];



    minWidthNumber = 15;
    minWidthText = 30;

    constructor(private readonly host: ElementRef, private readonly plannedRouteService: PlannedRouteService) {
    }

    ngOnInit(): void {
        this.setupProgressBar();
    }

    ngOnChanges() {
        this.setupProgressBar();
    }

    setupProgressBar() {
        if (!this.route?.PlannedVisits && !this.routes) {
            return;
        }

        const routeVisits = this.route
            ? this.route.PlannedVisits
            : selectMany(this.routes, r => r.PlannedVisits);

        this.calculatePercentages(routeVisits);
    }

    ngAfterViewInit() {
        const maxComponentWidth = (this.host.nativeElement as HTMLElement).clientWidth;

        this.minWidthNumber = 50 * 100 / maxComponentWidth;
        this.minWidthText = 100 * 100 / maxComponentWidth;
    }

    // ---

    private calculatePercentages(visits: IPlannedRouteVisit[]) {

        const s1 = this.createSegment(visits, VisitOnTimeStatus.Early, "early");
        const s2 = this.createSegment(visits, VisitOnTimeStatus.OnTime, "on time");
        const s3 = this.createSegment(visits, VisitOnTimeStatus.Late, "late");
        const s4 = this.createSegment(visits, VisitOnTimeStatus.Missed, "missed");

        this.segments = [s1, s2, s3, s4];
    }

    private createSegment(visits: IPlannedRouteVisit[], status: VisitOnTimeStatus, label: string): IBarSegment {
        // This is not efficient... May need to reconsider on large pages
        const count = visits.filter(v => this.plannedRouteService.getArrivalVisitOnTimeStatus(v) == status).length;
        const totalVisitCount = visits.filter(v => this.plannedRouteService.getArrivalVisitOnTimeStatus(v) != null).length;

        const percentage = count * 100 / totalVisitCount;

        const segment: IBarSegment = {
            count: count,
            label: label,
            className: VisitOnTimeStatus[status].toLowerCase(),
            percentage: percentage,
            showNumber: percentage > this.minWidthNumber,
            showText: percentage > this.minWidthText,
            showPercentage: true
        };

        if (!segment.showNumber || !segment.showText) {
            const percentageString = (segment.percentage / 100).toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 0 });
            segment.tooltip = `${percentageString} ${segment.label}`;
        }

        return segment;
    }
}
